import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../store/StoreProvider";
import Act from "../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../config/CONSTANTS";
import urls from "../../../api/project/ApiUrls";
import featureDisplay from "../../../common/utils/featureDisplay";
import TemplateHome from "../../components/TemplateHome";
//
import BaseMapImage from "../../../../images/home_basemap/home_basemap@2x.webp";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  position: "relative",
}));

const StyledImg = styled(
  "img",
  {}
)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  // top: 0,
  // left: 0,
}));

const HomeBg = ({ children }) => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  return (
    <StyledBox>
      <StyledImg src={BaseMapImage} id="home-bg-basemap" alt="" />
      <Box zIndex={50}>{children}</Box>
    </StyledBox>
  );
};

HomeBg.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

HomeBg.defaultProps = {
  children: null,
};

export default HomeBg;
